import React, { useEffect, useState } from 'react';
import "./birthday.css";
import Countdown from 'react-countdown';
import { useTypewriter } from 'react-simple-typewriter';
import { motion, useAnimate } from "framer-motion";
import NiviBDay1 from '../../images/nivi_bday_25_1.gif';
import NiviBDay2 from '../../images/nivi_bday_25_yay.gif';
import CakeWithoutFlame from '../../images/cake_without_flame.png';
import NiviHat from '../../images/nivi_hat_2.png';
import NiviGarland from '../../images/nivi_flyer.png';
import Flame from '../../images/flame.png';
import ParticlesWrapper from '../particlesV2';
import { tsParticles } from "@tsparticles/engine";
import confetti_25 from '../../configs/confetti_25';
 import { loadImageShape } from "@tsparticles/shape-image";

function Birthday2025() {
  const [blown, setBlown] = useState(false);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [cakeRef, animateCake] = useAnimate()
  const [flameRef, animateFlame] = useAnimate()
  const [niviRef, animateNivi] = useAnimate()
  const [hatRef, animateHat] = useAnimate()
  const [textRef, animateText] = useAnimate()

  // Refs for cleanup
  const streamRef = React.useRef(null);
  const sourceRef = React.useRef(null);
  const audioCtxRef = React.useRef(null);
  const animationIdRef = React.useRef(null);
  const analyserRef = React.useRef(null);

  const images = [
    NiviBDay1,
    NiviBDay2,
    CakeWithoutFlame,
    NiviHat,
    NiviGarland,
  ];

  async function initMic() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;
      return stream;
    } catch (err) {
      console.error("Microphone access denied:", err);
    }
  }

  async function detectBlow(onBlow) {
    const stream = await initMic();
    if (!stream) return;

    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    audioCtxRef.current = audioCtx;
    const source = audioCtx.createMediaStreamSource(stream);
    sourceRef.current = source;
    const analyser = audioCtx.createAnalyser();
    analyserRef.current = analyser;

    source.connect(analyser);
    analyser.fftSize = 256;

    const dataArray = new Uint8Array(analyser.frequencyBinCount);

    function checkVolume() {
      analyser.getByteFrequencyData(dataArray);

      // Calculate average volume
      let values = 0;
      for (let i = 0; i < dataArray.length; i++) {
        values += dataArray[i];
      }
      let average = values / dataArray.length;

      // Threshold (tweak for sensitivity)
      if (average > 80) {
        onBlow();
        cancelAnimationFrame(animationIdRef.current);
        analyser.disconnect();
        source.disconnect();
        stream.getTracks().forEach(track => track.stop());
        audioCtx.close();
        return;
      }

      animationIdRef.current = requestAnimationFrame(checkVolume);
    }

    checkVolume();
  }

  // Cleanup function to stop mic on unmount
  const cleanupMic = () => {
    if (animationIdRef.current) {
      cancelAnimationFrame(animationIdRef.current);
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }
    if (audioCtxRef.current) {
      audioCtxRef.current.close();
      audioCtxRef.current = null;
    }
    if (sourceRef.current) {
      sourceRef.current.disconnect();
      sourceRef.current = null;
    }
    if (analyserRef.current) {
      analyserRef.current.disconnect();
      analyserRef.current = null;
    }
  };


  useEffect(() => {
    let loadedCount = 0;
  
    const preloadImage = (src) => {
      return new Promise((resolve) => {
        const img = new Image();
        img.src = src;
        img.onload = () => {
          loadedCount++;
          if (loadedCount === images.length) {
            setImagesLoaded(true); // All images are loaded
          }
          resolve();
        };
        img.onerror = resolve; // Prevent blocking if image fails
      });
    };

    Promise.all(images.map(preloadImage));
    initMic();
    detectBlow(blow);

    return () => {
      cleanupMic();
    }
  }, []);

  const launchConfetti = async () => {
    await loadImageShape(tsParticles);
    tsParticles.load(confetti_25);
  };

  async function blow() {
    if (!blown) {
      await animateFlame(flameRef.current, { scale: 0 })
      setTimeout(async () => {
        await animateCake(cakeRef.current, { scale: 0 })
      }, 4000);
      setTimeout(async () => {
        await animateNivi(niviRef.current, { scale: 0.8 })
        await animateText(textRef.current, { scale: 1 })
        await animateHat(hatRef.current, { scale: 0.8, y: 30 })
      }, 7000);
      launchConfetti();
      setBlown(true);
    }
  }

  if (!imagesLoaded) return null;
  
  return (
    <div className='wrapper-bday-25'>
      <motion.img
        style={{ position: 'absolute', top: -10 }}
        width="80%"
        src={NiviGarland}
        alt={"Akshit Smile"}
        className="rounded-lg shadow-lg"
        initial={{ scale: 1 }}
      />
      <motion.img
        ref={hatRef}
        style={{ marginLeft: 100 }}
        width="70"
        src={NiviHat}
        alt={"Akshit Smile"}
        className="rounded-lg shadow-lg"
        initial={{ scale: 1 }}
        whileHover={{ scale: 1.1 }} // Slight zoom on hover
      />
      <motion.img
        ref={niviRef}
          width="200"
          src={blown ? NiviBDay2 : NiviBDay1}
          alt={"Akshit Smile"}
          className="rounded-lg shadow-lg"
          initial={{ scale: 1 }}
          // animate={{ scale: [1, 1.2, 1.1, 1] }} // Zoom in, bounce, then return to normal
          // transition={{ duration: 0.6, ease: [0.42, 0, 0.58, 0.6] }}
          // whileHover={{ scale: 1.1 }} // Slight zoom on hover
          // whileTap={{ scale: getAkshitImageScaleForNo() }}
          // onTap={() => {
          //     if ("vibrate" in navigator) {
          //         navigator.vibrate(50); // Vibrate for 50ms
          //     }
          // }}
          // ref={akshitImageRef}
      />
      <motion.div 
        className='birthday-2025-text'
        // style={{ position: 'absolute', top: '50%' }}
        ref={textRef}
        initial={{ scale: 0 }}
      >
        <p>HAPPY 23'RD BIRTHDAY NIVI!</p>
      </motion.div>
      <div style={{ position: "relative", display: "inline-block", marginTop: -45 }}>
        <motion.img
          ref={flameRef}
          style={{
            position: "absolute",
            top: "-40px",          // adjust vertical position
            left: "45%",           // move horizontally to center
            transform: "translateX(-50%)", // align center
            transformOrigin: "center bottom", 
          }}
          width="20"
          src={Flame}
          whileHover={{ scale: 1.1 }}
          className="rounded-lg shadow-lg"
          initial={{ scale: 1, opacity: 1 }}
          animate={{ 
            // scale: [1, 1.1, 0.95, 1.05, 1],
            // opacity: [0.8, 1, 0.85, 0.95, 0.9],
            rotate: [-2, 1, -1, 2, 0], // subtle tilt
          }}
          transition={{
            duration: 2.2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
        <motion.img
          ref={cakeRef}
          style={{ marginTop: -7 }}
          width="200"
          src={CakeWithoutFlame}
          className="rounded-lg shadow-lg"
          initial={{ scale: 1 }}
          whileHover={{ scale: 1.1 }} // Slight zoom on hover
        />
      </div>
      <div className='particles-container'><ParticlesWrapper config={"valentine_2025"} id="tsparticles_confetti_25" /></div>
    </div> 
  )
}

function getTextFor(type, value) {
    if (value === 0) {
      return ''
    }
    if (value > 1) {
      return type
    }
    switch(type) {
      case 'days':
        return 'day'
      case 'hours':
        return 'hour'
      case 'minutes':
        return 'minute'
      case 'seconds':
        return 'second'
    }
  }
  
  const Timer = () => {
    const [text] = useTypewriter({
      words: ['happy 23`rd birthday nivi!'],
      loop: 1,
    })
    return <Countdown
      date={1756492200000}
      // date={1661663881000}
      renderer={({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
          // Render a completed state
          return <Birthday2025 />;
        } else {
          // Render a countdown
          return <span className='App-content animated-grandient-bg birthday-2025-countdown'>{days !== 0 ? days : ''} {getTextFor('days', days)} {hours !== 0 ? hours : ''} {getTextFor('hours', hours)} {minutes !== 0 ? minutes : ''} {getTextFor('minutes', minutes)} {seconds !== 0 ? seconds : ''} {getTextFor('seconds', seconds)}</span>;
        }
      }}
    />
  }

export default Timer